<template>
  <div>
    <v-btn @click="generateReport" color="primary" class="mb-4">
      Generate Lease Expiry Report
    </v-btn>
    
    <v-data-table
      v-if="reportData"
      :headers="headers"
      :items="reportData"
    >
      <template v-slot:item.expiryDate="{ item }">
        {{ formatDate(item.expiryDate) }}
      </template>
      <template v-slot:item.daysRemaining="{ item }">
        <v-chip :color="getDaysRemainingColor(item.daysRemaining)">
          {{ item.daysRemaining }}
        </v-chip>
      </template>
    </v-data-table>
  </div>
</template>

<script>
export default {
  props: {
    property: Object,
    unit: Object
  },
  data() {
    return {
      reportData: null,
      headers: [
        { text: 'Lease Ref', value: 'leaseReference' },
        { text: 'Tenant', value: 'tenantName' },
        { text: 'Expiry Date', value: 'expiryDate' },
        { text: 'Days Remaining', value: 'daysRemaining' }
      ]
    };
  },
  methods: {
    async generateReport() {
      try {
        let queryRef = collection(db, 'Leases');
        if (this.property) {
          queryRef = query(
            queryRef,
            where('propertyId', '==', this.property.id)
          );
          if (this.unit) {
            queryRef = query(
              queryRef,
              where('unitId', '==', this.unit.id)
            );
          }
        }
        
        const snapshot = await getDocs(queryRef);
        const today = new Date();
        
        this.reportData = snapshot.docs.map(doc => {
          const data = doc.data();
          const expiryDate = new Date(data.leaseDetails.endDate);
          const daysRemaining = Math.floor((expiryDate - today) / (1000 * 60 * 60 * 24));
          
          return {
            ...data,
            expiryDate: data.leaseDetails.endDate,
            daysRemaining
          };
        }).sort((a, b) => a.daysRemaining - b.daysRemaining);
        
      } catch (error) {
        console.error("Error generating lease expiry report:", error);
      }
    },
    formatDate(date) {
      return new Date(date).toLocaleDateString();
    },
    getDaysRemainingColor(days) {
      if (days < 0) return 'error';
      if (days < 30) return 'warning';
      return 'success';
    }
  }
};
</script>